import auth from './auth';
import user from './user';

export const nl_auth = {
    auth,
    user
}